import { Divider, Grid, styled } from "@mui/material";
import React, { useEffect } from "react";
import { useParams, useSearchParams } from "react-router-dom";

import Card from "components/Card";
import CardSkeleton from "components/Skeletons/Card.Skeleton";
import InvestmentCard from "./Component/InvestmentCard";
import Pagination from "components/Pagination";
import { formatDateToJalali } from "utils/helpers/time";
import { getPortfolioTradeAvgForCoinList } from "store/slices/portfolio/portfolioSlice";
import useDispatch from "hooks/useDispatch";
import { useSelector } from "react-redux";

function BoxPortfolioTradeCoinList() {
  const dispatch = useDispatch();
  const { id } = useParams();

  const [searchParams] = useSearchParams();
  const startDate = searchParams.get("startDate") || "";
  const walletType = +searchParams.get("walletType") || 0;
  const portfolioDate = +searchParams.get("portfolioDate") || 0;

  const pageNumber = searchParams.get("page") || 1;
  const pageSize = searchParams.get("perPage") || 5;

  const portfolioSingleTradeList = useSelector(
    (state) => state.portfolio.portfolioSingleTradeList
  );

  useEffect(() => {
    dispatch(
      getPortfolioTradeAvgForCoinList({
        coinId: id,
        dateTypeId: portfolioDate,
        walletTypeId: walletType,
        pageNumber,
        pageSize,
        startDate: formatDateToJalali(startDate),
      })
    );

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [walletType, portfolioDate, id, startDate, pageSize, pageNumber]);

  return (
    <Grid container spacing={1}>
      <Grid item xs={12} mt={2}>
        {portfolioSingleTradeList?.data ? (
          <Card maxHeight="initial">
            {portfolioSingleTradeList?.data?.map((portfolioSingleTradeItem) => (
              <>
                <InvestmentCard
                  portfolioSingleTradeItem={portfolioSingleTradeItem}
                />
                <DividerStyle width={"100%"} />
              </>
            ))}
          </Card>
        ) : (
          <CardSkeleton heightSize={172} />
        )}
      </Grid>

      <Grid item xs={12}>
        <Pagination
          perPage={portfolioSingleTradeList?.pageSize}
          count={portfolioSingleTradeList?.totalPages}
          onChange={() => {}}
        />
      </Grid>
    </Grid>
  );
}

const DividerStyle = styled(Divider)(({ theme }) => ({
  borderColor: theme.palette.primary.dark,
}));
export default BoxPortfolioTradeCoinList;
